(function () {
  if (window.__naturalStorepointThemeInitialized) return;
  window.__naturalStorepointThemeInitialized = true;

  var SCRIPT_URL = 'https://widget.storepoint.co/embed.js';
  var SCRIPT_SELECTOR = 'script[data-natural-storepoint-script]';
  var LOAD_TIMEOUT = 15000;
  var REQUEST_DIALOG_MOTION = 220;
  var GOOGLE_MAP_ERROR_SELECTOR = [
    '.gm-err-container',
    '.gm-err-message',
    '.gm-err-title'
  ].join(',');

  function loadStorepointScript() {
    if (typeof window.StorepointWidget === 'function') {
      return Promise.resolve();
    }

    if (window.__naturalStorepointScriptPromise) {
      return window.__naturalStorepointScriptPromise;
    }

    window.Storepoint = window.Storepoint || {
      _q: [],
      on: function (eventName, callback) {
        this._q.push([eventName, callback]);
      }
    };

    window.__naturalStorepointScriptPromise = new Promise(function (resolve, reject) {
      var existingScript = document.querySelector(SCRIPT_SELECTOR);
      var scriptTimeout = window.setTimeout(handleError, LOAD_TIMEOUT);

      function handleLoad() {
        window.clearTimeout(scriptTimeout);

        if (typeof window.StorepointWidget === 'function') {
          resolve();
          return;
        }

        reject(new Error('Storepoint loaded without exposing its widget constructor.'));
      }

      function handleError() {
        window.clearTimeout(scriptTimeout);
        reject(new Error('Storepoint failed to load.'));
      }

      if (existingScript) {
        existingScript.addEventListener('load', handleLoad, { once: true });
        existingScript.addEventListener('error', handleError, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = SCRIPT_URL;
      script.async = true;
      script.dataset.naturalStorepointScript = '';
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
      document.head.appendChild(script);
    });

    return window.__naturalStorepointScriptPromise;
  }

  function setState(section, state) {
    var frame = section.querySelector('[data-storepoint-frame]');
    var status = section.querySelector('[data-storepoint-status]');
    var fallback = section.querySelector('[data-storepoint-fallback]');

    section.dataset.storepointState = state;

    if (frame) {
      frame.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    }

    if (status) {
      status.hidden = state !== 'loading';
    }

    if (fallback) {
      fallback.hidden = state !== 'error';
    }
  }

  function showMapFallback(section, host) {
    if (section.dataset.storepointMapState === 'error') return;

    var errorElement = host.querySelector(GOOGLE_MAP_ERROR_SELECTOR);
    if (!errorElement) return;

    var map = errorElement.closest('.storepoint-map') || host.querySelector('.storepoint-map');
    var template = section.querySelector('[data-storepoint-map-fallback-template]');

    if (!map || !template || !template.content) return;

    var fallback = template.content.firstElementChild.cloneNode(true);

    errorElement.setAttribute('aria-hidden', 'true');
    map.classList.add('natural-storepoint-map--error');
    map.appendChild(fallback);
    section.dataset.storepointMapState = 'error';

    var frame = section.querySelector('[data-storepoint-frame]');
    if (frame) frame.setAttribute('aria-busy', 'false');
  }

  function scheduleMapHealthCheck(section, host) {
    if (section.__naturalStorepointHealthFrame) return;

    section.__naturalStorepointHealthFrame = window.requestAnimationFrame(function () {
      section.__naturalStorepointHealthFrame = null;

      if (!section.isConnected || section.dataset.storepointMapState === 'error') return;
      showMapFallback(section, host);
    });
  }

  function destroyStorepoint(section) {
    section.__naturalStorepointGeneration = (section.__naturalStorepointGeneration || 0) + 1;

    if (section.__naturalStorepointTimeout) {
      window.clearTimeout(section.__naturalStorepointTimeout);
      section.__naturalStorepointTimeout = null;
    }

    if (section.__naturalStorepointObserver) {
      section.__naturalStorepointObserver.disconnect();
      section.__naturalStorepointObserver = null;
    }

    if (section.__naturalStorepointErrorObserver) {
      section.__naturalStorepointErrorObserver.disconnect();
      section.__naturalStorepointErrorObserver = null;
    }

    if (section.__naturalStorepointHealthFrame) {
      window.cancelAnimationFrame(section.__naturalStorepointHealthFrame);
      section.__naturalStorepointHealthFrame = null;
    }

    if (
      section.__naturalStorepointInstance &&
      typeof section.__naturalStorepointInstance.destroy === 'function'
    ) {
      section.__naturalStorepointInstance.destroy();
    }

    section.__naturalStorepointInstance = null;
    delete section.dataset.naturalStorepointMounted;
    delete section.dataset.storepointMapState;

    var host = section.querySelector('[data-storepoint-host]');
    if (host) {
      host.replaceChildren();
    }
  }

  function mountStorepoint(section) {
    if (!section || section.dataset.naturalStorepointMounted === 'true') return;

    var widgetId = (section.dataset.storepointWidgetId || '').trim();
    var host = section.querySelector('[data-storepoint-host]');

    if (!widgetId || !host || !host.id) return;

    section.__naturalStorepointGeneration = (section.__naturalStorepointGeneration || 0) + 1;
    var generation = section.__naturalStorepointGeneration;

    section.dataset.naturalStorepointMounted = 'true';
    setState(section, 'loading');

    loadStorepointScript()
      .then(function () {
        if (section.__naturalStorepointGeneration !== generation || !section.isConnected) return;

        var selector = '#' + window.CSS.escape(host.id);
        var instance = new window.StorepointWidget(widgetId, selector, {});
        var ready = false;

        function markReady() {
          if (
            ready ||
            section.__naturalStorepointGeneration !== generation ||
            !section.isConnected
          ) {
            return;
          }

          ready = true;

          if (section.__naturalStorepointTimeout) {
            window.clearTimeout(section.__naturalStorepointTimeout);
            section.__naturalStorepointTimeout = null;
          }

          if (section.__naturalStorepointObserver) {
            section.__naturalStorepointObserver.disconnect();
            section.__naturalStorepointObserver = null;
          }

          setState(section, 'ready');
        }

        section.__naturalStorepointInstance = instance;

        if (typeof instance.on === 'function') {
          instance.on('load', markReady);
        }

        section.__naturalStorepointObserver = new MutationObserver(function () {
          if (host.childElementCount > 0) markReady();
        });
        section.__naturalStorepointObserver.observe(host, { childList: true, subtree: true });

        section.__naturalStorepointErrorObserver = new MutationObserver(function () {
          scheduleMapHealthCheck(section, host);
        });
        section.__naturalStorepointErrorObserver.observe(host, { childList: true, subtree: true });
        scheduleMapHealthCheck(section, host);

        section.__naturalStorepointTimeout = window.setTimeout(function () {
          if (!ready && section.__naturalStorepointGeneration === generation) {
            destroyStorepoint(section);
            setState(section, 'error');
          }
        }, LOAD_TIMEOUT);

        if (typeof instance.load === 'function') {
          instance.load();
        } else {
          throw new Error('Storepoint widget lifecycle is unavailable.');
        }
      })
      .catch(function () {
        if (section.__naturalStorepointGeneration !== generation || !section.isConnected) return;

        destroyStorepoint(section);
        setState(section, 'error');
      });
  }

  function initializeStorepoint(root) {
    var sections = [];

    if (root.matches && root.matches('[data-natural-storepoint-section]')) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections = sections.concat(Array.from(root.querySelectorAll('[data-natural-storepoint-section]')));
    }

    sections.forEach(mountStorepoint);
  }

  function updateRequestDialogPageLock() {
    var hasOpenDialog = document.querySelector(
      '[data-natural-location-request-dialog][open]'
    );

    document.documentElement.classList.toggle(
      'natural-location-request-open',
      Boolean(hasOpenDialog)
    );
  }

  function prefillRequestArea(dialog) {
    var field = dialog.querySelector('[data-location-request-area]');
    if (!field || field.value.trim()) return;

    var page = dialog.closest('.natural-locator-page');
    var search = page
      ? page.querySelector(
          '.google-geocoder-input, [aria-label="Search by city, ZIP code, or address"]'
        )
      : null;
    var searchValue = search && typeof search.value === 'string' ? search.value.trim() : '';

    if (searchValue) field.value = searchValue;
  }

  function finishRequestDialogClose(dialog) {
    if (dialog.__naturalLocationRequestCloseTimer) {
      window.clearTimeout(dialog.__naturalLocationRequestCloseTimer);
      dialog.__naturalLocationRequestCloseTimer = null;
    }

    delete dialog.dataset.state;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      updateRequestDialogPageLock();
    }
  }

  function closeRequestDialog(dialog, restoreFocus) {
    if (!dialog || !dialog.hasAttribute('open')) return;

    if (dialog.__naturalLocationRequestCloseTimer) {
      window.clearTimeout(dialog.__naturalLocationRequestCloseTimer);
      dialog.__naturalLocationRequestCloseTimer = null;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    dialog.dataset.state = 'closing';
    dialog.__naturalLocationRequestRestoreFocus = restoreFocus !== false;

    if (prefersReducedMotion) {
      finishRequestDialogClose(dialog);
      return;
    }

    dialog.__naturalLocationRequestCloseTimer = window.setTimeout(function () {
      finishRequestDialogClose(dialog);
    }, REQUEST_DIALOG_MOTION);
  }

  function openRequestDialog(dialog, opener) {
    if (!dialog) return;

    if (dialog.__naturalLocationRequestCloseTimer) {
      window.clearTimeout(dialog.__naturalLocationRequestCloseTimer);
      dialog.__naturalLocationRequestCloseTimer = null;
    }

    dialog.__naturalLocationRequestOpener = opener || null;
    dialog.__naturalLocationRequestRestoreFocus = true;
    prefillRequestArea(dialog);

    if (!dialog.hasAttribute('open')) {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    updateRequestDialogPageLock();

    window.requestAnimationFrame(function () {
      if (!dialog.hasAttribute('open')) return;

      dialog.dataset.state = 'open';

      var focusTarget = dialog.querySelector(
        '[data-location-request-result], input:not([type="hidden"]), textarea'
      );

      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus({ preventScroll: true });
      }
    });
  }

  function initializeRequestDialogs(root) {
    var dialogs = [];

    if (root.matches && root.matches('[data-natural-location-request-dialog]')) {
      dialogs.push(root);
    }

    if (root.querySelectorAll) {
      dialogs = dialogs.concat(
        Array.from(root.querySelectorAll('[data-natural-location-request-dialog]'))
      );
    }

    dialogs.forEach(function (dialog) {
      if (dialog.dataset.naturalLocationRequestInitialized === 'true') return;

      dialog.dataset.naturalLocationRequestInitialized = 'true';

      var controller = new AbortController();
      var signal = controller.signal;
      var page = dialog.closest('.natural-locator-page') || document;
      var opener = page.querySelector(
        '[data-location-request-open][aria-controls="' + window.CSS.escape(dialog.id) + '"]'
      );
      var closeButton = dialog.querySelector('[data-location-request-close]');

      dialog.__naturalLocationRequestController = controller;

      if (opener) {
        opener.addEventListener(
          'click',
          function () {
            openRequestDialog(dialog, opener);
          },
          { signal: signal }
        );
      }

      if (closeButton) {
        closeButton.addEventListener(
          'click',
          function () {
            closeRequestDialog(dialog, true);
          },
          { signal: signal }
        );
      }

      dialog.addEventListener(
        'cancel',
        function (event) {
          event.preventDefault();
          closeRequestDialog(dialog, true);
        },
        { signal: signal }
      );

      dialog.addEventListener(
        'keydown',
        function (event) {
          if (event.key !== 'Escape') return;

          event.preventDefault();
          closeRequestDialog(dialog, true);
        },
        { signal: signal }
      );

      dialog.addEventListener(
        'click',
        function (event) {
          if (event.target === dialog) closeRequestDialog(dialog, true);
        },
        { signal: signal }
      );

      dialog.addEventListener(
        'close',
        function () {
          delete dialog.dataset.state;
          updateRequestDialogPageLock();

          if (
            dialog.__naturalLocationRequestRestoreFocus !== false &&
            dialog.__naturalLocationRequestOpener &&
            dialog.__naturalLocationRequestOpener.isConnected
          ) {
            dialog.__naturalLocationRequestOpener.focus({ preventScroll: true });
          }
        },
        { signal: signal }
      );

      if (dialog.querySelector('[data-location-request-result]')) {
        openRequestDialog(dialog, null);
      }
    });
  }

  function destroyRequestDialogs(root) {
    var dialogs = [];

    if (root.matches && root.matches('[data-natural-location-request-dialog]')) {
      dialogs.push(root);
    }

    if (root.querySelectorAll) {
      dialogs = dialogs.concat(
        Array.from(root.querySelectorAll('[data-natural-location-request-dialog]'))
      );
    }

    dialogs.forEach(function (dialog) {
      dialog.__naturalLocationRequestRestoreFocus = false;
      finishRequestDialogClose(dialog);

      if (dialog.__naturalLocationRequestController) {
        dialog.__naturalLocationRequestController.abort();
        dialog.__naturalLocationRequestController = null;
      }

      delete dialog.dataset.naturalLocationRequestInitialized;
    });

    updateRequestDialogPageLock();
  }

  function initializeLocatorPage(root) {
    initializeStorepoint(root);
    initializeRequestDialogs(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeLocatorPage(document);
    });
  } else {
    initializeLocatorPage(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeLocatorPage(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section =
      event.target.matches && event.target.matches('[data-natural-storepoint-section]')
        ? event.target
        : event.target.querySelector('[data-natural-storepoint-section]');

    if (section) destroyStorepoint(section);
    destroyRequestDialogs(event.target);
  });
})();
